import script from "./MultiSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiSelect.vue?vue&type=script&lang=ts&setup=true"

import "./MultiSelect.vue?vue&type=style&index=0&id=69cf6b25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69cf6b25"]])

export default __exports__